<template>
  <div>
    <div class="card-container">
      <a-tabs type="card">
        <a-tab-pane key="1" tab="专题导航">
          <div class="tabInner">
             <!-- <router-link to="/specDyDetail" tag="div"> -->
             <router-link :to="{path: '/special',query: { classId: classId, classCName: classCName },}" tag="div">
              <img src="../../../../static/img/index/menu01.png" alt="" />
              <div>骨干、特色专业申报</div>
            </router-link>
             <!-- <router-link to="/specDyDetail_02" tag="div">
              <img src="../../../../static/img/index/menu01.png" alt="" />
              <div>人才培养档案</div>
            </router-link> -->
             <router-link :to="{path: '/special',query: { classId: ren_classId, classCName: ren_classCName },}" tag="div">
              <img src="../../../../static/img/index/menu01.png" alt="" />
              <div>人才培养方案</div>
            </router-link>
               <a href=""  tag="a" target="_blank" style="display:block;">
              <img src="../../../../static/img/index/menu02.png" alt="" />
              <div>学校人人通空间</div>
              <!-- <div>智慧校园</div> -->
            </a>
            <a href="http://www.ynzjzx.com:8081/"  tag="a" target="_blank" style="display:block;">
              <img src="../../../../static/img/index/menu02.png" alt="" />
              <!-- <div>数字化校园平台</div> -->
              <div>智慧校园</div>
            </a>
            <!-- <router-link to="" tag="div">
              <img src="../../../../static/img/index/menu03.png" alt="" />
              <div>精品课程</div>
            </router-link> -->
             <!-- <a href="http://www.ynzjzx.com:81"  tag="a" target="_blank" style="display:block;">
              <img src="../../../../static/img/index/menu03.png" alt="" />
              <div>精品课程</div>
            </a> -->
            <!-- <a href="https://yunpan.ynzjzx.com:20000/d/7e7335bf16/"  tag="a" target="_blank" style="display:block;">
              <img src="../../../../static/img/index/menu03.png" alt="" />
              <div>课程资源库</div>
            </a> -->
            <!-- <router-link to="" tag="div">
              <img src="../../../../static/img/index/menu04.png" alt="" />
              <div>云资源平台</div>
            </router-link> -->
            <a href="https://hdynzj.cnzj5u.com/"  tag="a" target="_blank" style="display:block;">
              <img src="../../../../static/img/index/menu04.png" alt="" />
              <div>云资源平台</div>
            </a>
            <router-link  :to="{ path: '/zhaosheng', query: { name: '在线报名' } }" tag="div">
              <img src="../../../../static/img/index/menu05.png" alt="" />
              <div>在线报名</div>
            </router-link>
            <!-- <router-link :to="{path: '/special',query: { classId: li_classId, classCName: li_classCName },}"  tag="div">
              <img src="../../../../static/img/index/menu01.png" alt="" />
              <div>现任领导</div>
            </router-link> -->
            <a href="http://zljc.ynzjzx.com:8081/quality"  tag="a" target="_blank" style="display:block;">
              <img src="../../../../static/img/index/menu04.png" alt="" />
              <div>教学诊改</div>
            </a>
            <router-link to="" tag="div">
              <img src="../../../../static/img/index/menu06.png" alt="" />
              <div>更多专题</div>
            </router-link>
            <router-link to="" tag="div" style="border: 0px;">
              <!-- <img src="../../../../static/img/index/menu06.png" alt="" />
              <div>更多专题</div> -->
            </router-link>
            
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
  import { postNewsByPage, getScList } from "../../../api/api";
export default {
  data() {
    return {
      list: [],
      isImg: false,
      classId: null,
      classCName: "",
      ren_classId:'',
      ren_classCName:'',
      li_classId:'',
      li_classCName:''
    };
  },
  created() {
    getScList().then((res) => {
      console.log(res,"栏目顺序");
      this.classId = res[13].classId;//骨干申报
      this.classCName = res[13].classCName;//骨干申报
       this.ren_classId = res[12].classId;//人才培养
      this.ren_classCName = res[12].classCName;//人才培养
       this.li_classId = res[4].child[3].classId;//现任领导
      this.li_classCName = res[4].child[3].classCName;//现任领导
    });
    postNewsByPage(19682205716332, 1, 4).then((res) => {
      // //console.log(res);？
      this.list = res.list;
    });
  },
};
</script>
<style scoped>
.card-container {
  overflow: hidden;
  box-shadow: 0px 0px 20px 0px rgba(0, 91, 176, 0.1);
  width: 100%;
  margin-left: 6px;
  position: relative;
}
.titleMore {
  position: absolute;
  top: 10%;
  right: 15px;
  z-index: 1;
  border-radius: 10px;
  font-size: 12px;
}
.ant-btn > .anticon + span,
.ant-btn > span + .anticon {
  margin-left: 0px !important;
}
.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 120px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

div /deep/.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
  background-image: url("../../../../static/img/index/menuNav.jpg");
  background-size: 100% 100%;
  margin: 0;
  padding: 30px;
  padding-bottom: 0;
}
div /deep/ .ant-tabs-tab {
  background: none !important;
  border: none !important;
  color: #fff !important;
  font-weight: bold;
}
div /deep/ .ant-tabs-tab-active {
  background: #fff !important;
  border-color: #e8e8e8 !important;
  border-bottom: 1px solid #fff !important;
  color: #1890ff !important;
  font-weight: bold;
}
.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: lightblue;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #fff;
  background: #fff;
}
.tabInner {
  display: flex;
  justify-content: space-between;
  color: #8c898d;
  line-height: 40px;
  flex-wrap: wrap;
}
.tabInner > div {
  width: 31%;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
  border: 1px solid rgb(233, 228, 228);
}
.tabInner > div:hover {
  color: #2280b0;
  border: 1px solid #2280b0;
  box-shadow: 0px 0px 20px 0px #2280b0;
  cursor: pointer;
}
.tabInner > a {
    width: 31%;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
    color: #8c898d;
    border: 1px solid rgb(233, 228, 228);
}
.tabInner > a:hover {
  color: #2280b0;
  border: 1px solid #2280b0;
  box-shadow: 0px 0px 20px 0px #2280b0;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/indexComp/smallComp/specilNav.vue